import { PaymentInterface } from './interfaces';

export const paymentInitialState: PaymentInterface = {
  methods: [],
};
